import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { PageLoader } from "./PageLoader";

interface AuthRedirectProps {
  children: React.ReactNode;
}

/**
 * Composant qui redirige automatiquement les utilisateurs authentifiés
 * vers la page d'accueil. Utilisé pour les pages de login et signup.
 */
export const AuthRedirect = ({ children }: AuthRedirectProps) => {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return <PageLoader />;
  }

  // Si l'utilisateur est déjà authentifié, le rediriger vers /
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
